<button type="button" mat-button [ngClass]="{'button-link': asLink}" (click)="getFile()">
    {{ rowData[fieldDefinition.text] }}
</button>
